import { useRouteQuery } from "@vueuse/router";

const useDebouncedRouteQuery = <T extends string | undefined>(
  queryParam: string,
  options?: {
    defaultValue?: MaybeRefOrGetter<T>;
    debounceAmount?: number;
  },
) => {
  const routeQuery = useRouteQuery<T>(queryParam, options?.defaultValue);

  return {
    query: routeQuery,
    debounced: refDebounced(routeQuery, options?.debounceAmount || 500),
  };
};

export default useDebouncedRouteQuery;
